

import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Card, Form, Modal } from "react-bootstrap";
import { fetch } from "../../utils";
import { Table } from "ka-table";
import "ka-table/style.css";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { FaClipboardList } from "react-icons/fa";

const bootstrapChildComponents = {
    table: {
        elementAttributes: () => ({
            className: "table table-striped table-hover table-bordered ",
        }),
    },
    tableHead: {
        elementAttributes: () => ({
            className: "thead-dark",
        }),
    },
    noDataRow: {
        content: () => "No Data Found",
    },
};

const AdminGST = () => {
    const [searchText, setSearchText] = useState("");
    const [searchTextTwo, setSearchTextTwo] = useState('');
    const [show, setShow] = useState(false);
    const [showTwo, setShowTwo] = useState(false);
    const [sizeData, setSizeData] = useState({
        list: [],
        loading: false,
    });

    const [attributeValueData, setAttributeValueData] = useState({
        attribute_id: 0,
        list: [],
        loading: false,
    });

    const [formLoading, setFormLoading] = useState(false);
    const [formMessage, setFormMessage] = useState(null);

    const [formLoading2, setFormLoading2] = useState(false);
    const [formMessage2, setFormMessage2] = useState(null);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setFormMessage(null);
        reset();
    };

    const handleCloseTwo = () => setShowTwo(false);
    const handleShowTwo = () => {
        setShowTwo(true);
        setFormMessage2(null);
        reset2();
    };
    useEffect(() => {
        // Reset the search input box when the modal is opened
        if (showTwo) {
            setSearchTextTwo('');
        }
    }, [showTwo]);

    const schema = z.object({
        gst_percent: z
            .string()
            .min(1, { message: "attribute name is required." }),

        // attribute_description: z
        //   .string()
        //   .min(1, { message: "attribute description is required." }),
    });

    const schema2 = z.object({
        attribute_value: z
            .string()
            .min(1, { message: "attribute value is required." }),
        attribute_type: z
            .string()
            .min(1, { message: "attribute type type is required." }),
        attribute_value_description: z
            .string()
            .min(1, { message: "attribute value description is required." }),
    });

    const {
        register: register2,
        handleSubmit: handleSubmit2,
        formState: { errors: errors2 },
        reset: reset2,
    } = useForm({
        defaultValues: {
            gst_percent: "",
        },
        resolver: zodResolver(schema2),
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        defaultValues: {
            gst_percent: "",
      
        },
        resolver: zodResolver(schema),
    });


    const onSubmit = async (data) => {
        try {
            setFormLoading(true);
            setFormMessage(
                <font color="blue">
                    <b>Loading....</b>
                </font>
            );
            const response = await fetch("gst/add", "POST", data, null);
            if (response.status === 201) {
                const { success, message } = response.data;
                if (success === true) {
                    setFormMessage(
                        <font color="green">
                            <b>{message}</b>
                        </font>
                    );
                    reset();
                    handleClose();
                    getSizeList();
                    return true;
                }
            }
            setFormMessage(
                <font color="red">
                    <b>{response.message}</b>
                </font>
            );
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                setFormMessage(<font color="red"><b>{error.response.data.message}</b></font>);
            } else if (error && error.message) {
                setFormMessage(<font color="red"><b>{error.message}</b></font>);
            } else {
                setFormMessage(<font color="red"><b>Something went wrong.</b></font>);
            }
        } finally {
            setFormLoading(false);
        }
    };


    const getSizeList = async () => {
        try {
            setSizeData((prev) => ({ list: [], loading: true }));
            const response = await fetch("gst/all", "GET", null, null);
            console.log('response', response)
            if (response.status === 200) {
                const { success, data } = response.data;
                if (success === true) {
                    const gst_list = data.gst_list;
                    const tableData = await gst_list.map((size, index) => {
                        return {
                            id: index + 1,
                            gst_percent: size.gst_percent,
                            display_status: {
                                display_status: size.display_status,
                                gst_id: size.gst_id,
                              },

                        };
                    });
                    setSizeData({ list: tableData, loading: false });
                }
            }
        } catch (error) {
            setSizeData({ list: [], loading: false });
        } finally {
            setSizeData((prev) => ({ list: prev.list, loading: false }));
        }
    };


    const setSizeDisplayStatus = async (gst_id, display_status) => {
        try {
            const response = await fetch(
                "gst/dispaly-status",
                "POST",
                {
                    gst_id: gst_id,
                    display_status: display_status ? 0 : 1,
                },
                null
            );

            if (response.status === 200) {
                const { success } = response.data;
                if (success === true) {
                    getSizeList();
                }
            }
        } catch (error) {
            if (
                error.response &&
                error.response.data &&
                error.response.data.message
            ) {
                alert(error.response.data.message);
            } else if (error.message) {
                alert(error.message);
            } else {
                alert("Something went wrong.");
            }
        }
    };


    useEffect(() => {
        getSizeList();
    }, []);

    return (
        <div className="container-fluid">
            <Breadcrumb className="p-2">
                <Breadcrumb.Item href="#">Dashboard</Breadcrumb.Item>
                <Breadcrumb.Item active>GST </Breadcrumb.Item>
            </Breadcrumb>

            {/* Modal */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add GST</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>GST</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter GST "
                                autoFocus
                                {...register("gst_percent")}
                                isInvalid={!!errors.gst_percent?.message}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.gst_percent?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form>
                    <div className="text-center">{formMessage ? formMessage : ""}</div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} size="sm">
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSubmit(onSubmit)}
                        disabled={formLoading}
                        size="sm"
                    >
                        Add
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Modal */}



            <section className="content">
                <div className="container-fluid">
                    <div className="row justify-content-md-center">

                        <div className="col-sm-8">
                            <Card>
                                <Card.Header>
                                    <h4>
                                        GST
                                        <button
                                            className="btn btn-sm btn-primary pull-right"
                                            onClick={handleShow}
                                        >
                                            Add GST
                                        </button>
                                    </h4>
                                </Card.Header>
                                <Card.Body>
                                    <div className="row">
                                        <div className="co-sm-12">
                                            <input
                                                type="search"
                                                value={searchText}
                                                onChange={(event) => {
                                                    setSearchText(event.currentTarget.value);
                                                }}
                                                className="top-element pull-right m-2"
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-12">
                                            <Table
                                                loading={{
                                                    enabled: sizeData.loading,
                                                    text: "Loading data",
                                                }}
                                                columns={[
                                                    {
                                                        key: "id",
                                                        title: "Sr.No.",
                                                        width: "5%",
                                                    },

                                                    {
                                                        key: "gst_percent",
                                                        title: "GST Percent",
                                                        width: "40%",
                                                   
                                                    },
                                                    

                                                    {
                                                        key: "display_status",
                                                        title: "Active",
                                                        style: { textAlign: "center" },
                                                        width: "10%",
                                                    },


                                                ]}
                                                format={({ column, value }) => {
                                                    if (column.key === "id") {
                                                        return `${value}.`;
                                                    }

                                                    if (column.key === "display_status") {
                                                        return (
                                                          <Form.Check
                                                            type="switch"
                                                            id="custom-switch"
                                                            checked={value.display_status ? true : false}
                                                            onChange={() => {
                                                              setSizeDisplayStatus(
                                                                value.gst_id,
                                                                value.display_status ? true : false
                                                              );
                                                            }}
                                                          />
                                                        );
                                                      }

                                                }}




                                                
                                                data={sizeData.list}
                                                search={({
                                                    searchText: searchTextValue,
                                                    rowData,
                                                    column,
                                                }) => {
                                                    if (column.key === "passed") {
                                                        return (
                                                            (searchTextValue === "false" && !rowData.passed) ||
                                                            (searchTextValue === "true" && rowData.passed)
                                                        );
                                                    }
                                                }}
                                                rowKeyField={"id"}
                                                searchText={searchText}
                                                noData={{
                                                    text: "No Data Found",
                                                }}
                                                childComponents={bootstrapChildComponents}
                                            />
                                        </div>
                                    </div>
                                </Card.Body>

                                <Card.Footer></Card.Footer>
                            </Card>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    );
};

export default AdminGST;
